import React from "react";
import { Gavel } from "lucide-react";
import { finApi, money } from "@/lib/financeApi";
import { Chip, ErrorBox, FinRoster, Loading, useLoad, useView } from "@/components/nds/windows/finance/parts";
import FinPenaltiesDetail from "@/components/nds/windows/finance/FinPenaltiesDetail";

export default function FinPenaltiesContent() {
  const [view, setView] = useView("penalties_view");
  const [selected, setSelected] = React.useState(null);
  const [state, load] = useLoad(() => Promise.all([finApi.get("/residents", { status: view }), finApi.get("/penalties", { status: "issued" })])
    .then(([r, p]) => {
      const open = {};
      p.penalties.forEach((x) => { open[x.resident_id] = (open[x.resident_id] || 0) + 1; });
      return { ...r, open };
    }), [view]);

  if (selected) return <FinPenaltiesDetail resident={selected} onBack={() => { setSelected(null); load(); }} />;
  return (
    <div data-testid="fin-penalties-content" className="flex flex-col h-full">
      {state.loading && !state.data ? <Loading testid="fin-penalties-loading" label="Loading penalties…" />
        : state.error ? <ErrorBox testid="fin-penalties-error" error={state.error} onRetry={load} />
        : (
          <FinRoster prefix="fin-penalties" icon={Gavel} view={view} setView={setView} counts={state.data.counts}
            residents={state.data.residents} onOpen={setSelected} onRefresh={load} owedOf={(r) => Math.max(-(r.balances?.penalty || 0), 0)}
            renderRight={(r) => {
              const owed = Math.max(-r.balances.penalty, 0);
              const n = state.data.open[r.id] || 0;
              return (
                <>
                  <Chip tone={n ? "yellow" : "grey"} data-testid={`fin-penalties-open-${r.id}`}>{n} open</Chip>
                  <Chip tone={owed > 0 ? "red" : "grey"} data-testid={`fin-penalties-owed-${r.id}`}>{money(owed)} owed</Chip>
                </>
              );
            }} />
        )}
    </div>
  );
}
